<template>
  <div class="slides" ref="slides" v-if="slideshow">
    <div
      class="slide"
      :key="j"
      ref="slide"
      v-for="(slide, j) in slideshow.slides"
    >
      <GallerySlide
        v-show="slide.id === slideshow.current"
        v-bind:slide="slide"
      />
    </div>
  </div>
</template>
<script>
const GallerySlide = () => import('./GallerySlide')

export default {
  components: { GallerySlide },
  props: {
    slideshow: {
      type: Object,
      required: true,
    },
  },
}
</script>
